import { Module } from '../Module';
import { UserSettings } from '../resources/UserSettings';
import { IResult } from '../ServerApi/types/IResponse';
import { UpdateUserDisplayNameNotification } from '../services/UserSettingsNotification';

// methods exposed outside the directive
export interface IEditDisplayNameControls {
  isBusy: () => boolean;
  isDirty: () => boolean;
  isValid: () => boolean;
  submit: (userId: string, username: string) => ng.IPromise<any>;
}

export interface IEditDisplayNameScope extends ng.IScope {
  busy: boolean;
  controls: IEditDisplayNameControls;
  displayName: string;
  displayNameForm: ng.IFormController;
  originalDisplayName: string;
}

Module.instance().directive('tbEditDisplayName', [
  'UpdateUserDisplayNameNotification',
  'UserSettings',
  (updateUserDisplayNameNotification: UpdateUserDisplayNameNotification,
   userSettings: UserSettings) => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'editDisplayName.html',
      scope: {
        displayName: '@',
        controls: '=?'
      },
      link: (scope: IEditDisplayNameScope) => {

        scope.busy = false;

        // save original displayName
        scope.originalDisplayName = scope.displayName;

        scope.controls = {
          // make backend request to update the display name
          submit: (userId: string, username: string) => {
            scope.busy = true;
            const displayName = scope.displayName;
            return userSettings.updateUserDisplayName(userId, displayName)
              .then((result: IResult) => {
                // toasts
                updateUserDisplayNameNotification.notify(result, username, displayName);
                scope.busy = false;
              });
          },
          isBusy: () => {
            return scope.busy;
          },
          // checks whether the field has been changed
          isDirty: () => {
            return scope.displayName !== scope.originalDisplayName;
          },
          // checks whether the input is valid
          isValid: () => {
            return !scope.displayNameForm.$invalid;
          }
        };
      }
    };
  }
]);
